import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './InfoDrawer.styles';
import {
  InfoOutlinedIcon,
  PaymentErrorIcon,
} from '@/components/UI/Icons/Icons';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { ROUTES } from '@/constants/routes';

interface InfoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  description: string;
  isError?: boolean;
  dataTestId?: string;
}

export const InfoDrawer: FC<InfoDrawerProps> = ({
  isOpen,
  onClose,
  description,
  isError = false,
  dataTestId,
}) => {
  const { t } = useTranslation();

  return (
    <S.InfoDrawer
      isInPortal
      isOpen={isOpen}
      isHeadHidden
      close={onClose}
      dataTestId={dataTestId}
    >
      <S.InfoDrawerWrapper>
        <S.InfoDrawerLogo />
        {isError ? <PaymentErrorIcon /> : <InfoOutlinedIcon />}
        <S.InfoDrawerTitle $isError={isError}>
          {t(`common.${isError ? 'payment_error' : 'attention'}`)}
        </S.InfoDrawerTitle>
        <S.InfoDrawerMessage>{description}</S.InfoDrawerMessage>
        <S.InfoDrawerButton onClick={onClose}>
          {t(`common.${isError ? 'try_again' : 'got_it'}`)}
        </S.InfoDrawerButton>
        {!isError && (
          <S.InfoDrawerLink as={CustomLink} href={ROUTES.payments}>
            {t('pages.cabinet.operations_history')}
          </S.InfoDrawerLink>
        )}
      </S.InfoDrawerWrapper>
    </S.InfoDrawer>
  );
};
